import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectFit = makeInflect("vejde", "vejdou", "vejde");
